import emitter from 'tiny-emitter/instance';

export const EventBusInstance = {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
  listen(type, cb) {
    this.$on(`state.${type}`, cb);
  },
  clean(type) {
    this.$off(`state.${type}`);
  },
};

export default EventBusInstance;

export function EventBusSetup(app) {
  app.config.globalProperties.$eventBus = EventBusInstance;
  app.config.globalProperties.$event = EventBusInstance;
}